import Description from 'components/assets/form_sections/AssetsFormDescription';
import General from 'components/assets/form_sections/AssetsFormGeneral';
import Location from 'components/assets/form_sections/AssetsFormLocation';
import Buy from 'components/assets/form_sections/AssetsFormBuy';
import Accountant from 'components/assets/form_sections/AssetsFormAccountant';
import Project from 'components/assets/form_sections/AssetsFormProject';
import Assurance from 'components/assets/form_sections/AssetsFormAssurance';
import Bill from 'components/assets/form_sections/AssetsFormBill';
import CustomFields from 'components/assets/form_sections/AssetsFormCustomFields';
import Files from 'components/assets/form_sections/AssetsFormFiles';
import Notes from 'components/assets/form_sections/AssetsFormNotes';
import Historics from 'components/assets/form_sections/AssetsFormHistorics';
import HistoricsRow from 'components/assets/form_sections/AssetFormHistoricsRow';
import Codes from 'components/assets/form_sections/AssetFormCodes';
import CodesLabel from 'components/assets/form_sections/AssetFormCodesLabel';
import CustomsDocuments from 'components/assets/form_sections/AssetFormCustomsDocuments';

export default {
  Description,
  General,
  Location,
  Buy,
  Accountant,
  Project,
  Assurance,
  Bill,
  CustomFields,
  Files,
  Notes,
  Historics,
  HistoricsRow,
  Codes,
  CodesLabel,
  CustomsDocuments,
};



// WEBPACK FOOTER //
// src/components/assets/form_sections/index.js